import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import CreaCasosJuridica from "./CrearCaso";
import { Button } from "antd";
import ConsultaActual from "./consultaTickets/ConsultaActual";
import GestionesJuridica from "./ConsultaGestiones";
import GestionSolicitante from "./GestionSoliictante";
import VerAnexos from "./VerAnexos";
import Cookies from "universal-cookie";

const cookies = new Cookies();

// ---------------- DESCRIPCION CORTA ------------------
const DescripcionCorta = ({ descripcion }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title={descripcion.length > 50 ? descripcion : ""}>
        <span>
          {descripcion.length > 50 ? `${descripcion.substring(0, 50)}... ` : descripcion}
          {descripcion.length > 50 && (
            <IconButton size="small" onClick={handleOpen}>
              <VisibilityIcon fontSize="small" />
            </IconButton>
          )}
        </span>
      </Tooltip>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Descripción Completa</DialogTitle>
        <DialogContent>{descripcion}</DialogContent>
      </Dialog>
    </>
  );
};

// ---------------- COMPONENTE PRINCIPAL ------------------
function SolicitudesPropias() {
  const { correo } = useParams(); // correo viene de la URL
  const [correoUsuario, setCorreoUsuario] = useState("");
  const [IdUsuario, setIdUsuario] = useState(null);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const [columns] = useState([
    { Header: "ID", accessor: "id" },
    { Header: "Título", accessor: "titulo" },
    { Header: "Estado", accessor: "name" },
    { Header: "Tema", accessor: "nombreTema" },
    {
      Header: "Descripción",
      accessor: "descripcion",
      Cell: ({ row }) => <DescripcionCorta descripcion={row.original.descripcion} />,
    },
    { Header: "Fecha Creación", accessor: "fechaCreacion" },
    { Header: "Usuario Creación", accessor: "nombreAsignacion" },
    { Header: "Usuario Asignación", accessor: "nombreCreacion" },
    { Header: "NIT", accessor: "nit" },
    {
      Header: "Caso Asociado",
      accessor: "casoAsociado",
      Cell: ({ row }) => <ConsultaActual id={row.original.id} />,
    },
    {
      Header: "Ver Gestiones",
      accessor: "gestionesJuridicas",
      Cell: ({ row }) => (
        <GestionesJuridica id={row.original.id} descripcion={row.original.descripcion} />
      ),
    },
    {
      Header: "Gestionar",
      accessor: "gestionSolicitante",
      Cell: ({ row }) =>
        row.original.name === "NUEVO" || row.original.name === "DEVUELTO" ? (
          <GestionSolicitante id={row.original.id} />
        ) : null,
    },
    {
      Header: "Ver Anexos",
      accessor: "verAnexos",
      Cell: ({ row }) => <VerAnexos id={row.original.id} />,
    },
  ]);

  // ---------------- 1. Guardar correo y ocultarlo en URL ----------------
  useEffect(() => {
    if (!correo) return;

    // Guardar en estado
    setCorreoUsuario(correo);

    // Guardar en cookies
    cookies.set("correo", correo, { path: "/" });

    // Cifrar correo en Base64 y reemplazar la URL
    const token = btoa(correo);
    const newUrl = window.location.pathname.replace(correo, token);
    window.history.replaceState(null, "", newUrl);
  }, [correo]);

  // ---------------- 2. Decodificar token si recarga la página ----------------
  useEffect(() => {
    const pathParts = window.location.pathname.split("/");
    const token = pathParts[pathParts.length - 1];
    try {
      const decoded = atob(token);
      setCorreoUsuario(decoded);
      cookies.set("correo", decoded, { path: "/" });
    } catch (e) {
      console.error("Token inválido");
    }
  }, []);

  // ---------------- 3. Obtener usuario por correo ----------------
  useEffect(() => {
    if (!correoUsuario) return;

    const fetchUsuario = async () => {
      try {
        const resp = await axios.get(
          `https://contratosback.azurewebsites.net/api/v1/ObtenerUsuariosLegal/${correoUsuario}`
        );
        if (resp.data.length > 0) {
          const user = resp.data[0];
          cookies.set("id", user.id, { path: "/" });
          cookies.set("tipo_Usuario", user.tipoUsuarioId, { path: "/" });
          setIdUsuario(user.id);
        }
      } catch (error) {
        console.error("Error obteniendo usuario:", error);
      }
    };

    fetchUsuario();
  }, [correoUsuario]);

  // ---------------- 4. Obtener solicitudes ----------------
  useEffect(() => {
    if (!cookies.get("id")) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const response = await axios.get(
          `https://contratosback.azurewebsites.net/api/v1/ObtenerJuridicoCreadas/${cookies.get(
            "id"
          )}`
        );

        const data = response.data.map((item) => ({
          id: item.id,
          titulo: item.titulo,
          nombreTema: item.nombreTema,
          descripcion: item.descripcion,
          fechaCreacionRaw: item.fechaCreacion,
          fechaCreacion: new Date(item.fechaCreacion).toLocaleDateString(),
          nombreCreacion: item.nombreCreacion,
          nombreAsignacion: item.nombreAsignacion,
          name: item.name,
          nit: item.nit,
        }));

        setRows(data.sort((a, b) => new Date(b.fechaCreacionRaw) - new Date(a.fechaCreacionRaw)));
        setLoading(false);
      } catch (error) {
        console.error("Error cargando solicitudes:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [cookies.get("id")]);

  // ---------------- FILTRO Y PAGINACIÓN ----------------
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const filteredRows = rows.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredRows.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentRows = filteredRows.slice(indexOfFirstItem, indexOfLastItem);

  // ------------------ RENDER ------------------
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Solicitudes Jurídicas
                </MDTypography>
              </MDBox>

              <MDBox pt={3} px={3}>
                <TextField
                  fullWidth
                  label="Buscar..."
                  variant="outlined"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ marginBottom: "20px" }}
                />

                <center>
                  <CreaCasosJuridica />
                </center>

                <hr />

                {loading ? (
                  <MDTypography align="center">Cargando solicitudes...</MDTypography>
                ) : (
                  <>
                    <MDTypography variant="body2" color="textSecondary" align="right" mb={1}>
                      {filteredRows.length} resultado(s) encontrado(s)
                    </MDTypography>

                    <DataTable
                      table={{ columns, rows: currentRows }}
                      isSorted={false}
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                    />

                    <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
                      <Button
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                      >
                        Anterior
                      </Button>

                      <MDTypography variant="body2">
                        Página {currentPage} de {totalPages}
                      </MDTypography>

                      <Button
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                      >
                        Siguiente
                      </Button>
                    </MDBox>
                  </>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default SolicitudesPropias;
